import React from 'react';
import './Filters.css';

const Filters = ({ data, filters, setFilters }) => {
  const customers = Array.from(new Set(data.map((d) => d.Customer)));
  const agents = Array.from(new Set(data.map((d) => d.Agent)));
  const toDateKey = (d) => {
    const dateObj = d.Date instanceof Date ? d.Date : new Date(d.Date);
    return dateObj.toLocaleDateString('en-CA');
  };
  const dates = Array.from(new Set(data.map(toDateKey))).sort();

  const handleChange = (field) => (e) => {
    setFilters({ ...filters, [field]: e.target.value });
  };

  const clearFilter = (field) => () => {
    setFilters({ ...filters, [field]: '' });
  };

  return (
    <div className="filters-container">
        <div className="filter-form">
          <div className="filter-group">
            <label>Klant</label>
            <select value={filters.customer} onChange={handleChange('customer')}>
              <option value="">Alles</option>
              {customers.map((cust) => (
                <option key={cust} value={cust}>{cust}</option>
              ))}
            </select>
          </div>

          <div className="filter-group">
            <label>Agent</label>
            <select value={filters.agent} onChange={handleChange('agent')}>
              <option value="">Alles</option>
              {agents.map((agent) => (
                <option key={agent} value={agent}>{agent}</option>
              ))}
            </select>
          </div>

          <div className="filter-group">
            <label>Datum</label>
            <select value={filters.selectedDate} onChange={handleChange('selectedDate')}>
              <option value="">Alles</option>
              {dates.map((date) => (
                <option key={date} value={date}>{date}</option>
              ))}
            </select>
          </div>
        </div>

        <div className="active-filters">
        {filters.customer && (
          <span className="filter-tag" onClick={clearFilter('customer')}>
            {filters.customer} ✕
          </span>
        )}
        {filters.agent && (
          <span className="filter-tag" onClick={clearFilter('agent')}>
            {filters.agent} ✕
          </span>
        )}
        {filters.selectedDate && (
          <span className="filter-tag" onClick={clearFilter('selectedDate')}>
            {filters.selectedDate} ✕
          </span>
        )}
      </div>
    </div>
  );
};

export default Filters;
